import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Language } from 'src/app/tools/language/language';
import { dataText } from './dataText';

@Component({
  selector: 'app-modal-accepts-terms',
  templateUrl: './modal-accepts-terms.component.html',
  styleUrls: ['./modal-accepts-terms.component.scss']
})
export class ModalAcceptsTermsComponent implements OnInit {
  lang: any = Language.currentLanguage.lenid;
  title: string;
  text: string;
  buttonTitle: string;

  constructor(
    public dialogRef: MatDialogRef<ModalAcceptsTermsComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) { }

  ngOnInit(): void {
    if (this.lang === 'es') {
      this.title = dataText.es.title;
      this.text = dataText.es.text;
      this.buttonTitle = dataText.es.buttonTitle;
    } else if (this.lang === 'en') {
      this.title = dataText.en.title;
      this.text = dataText.en.text;
      this.buttonTitle = dataText.en.buttonTitle;
    } else if (this.lang === 'pt') {
      this.title = dataText.pt.title;
      this.text = dataText.pt.text;
      this.buttonTitle = dataText.pt.buttonTitle;
    }
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

}
